import { EnvironmentUrls } from 'Roblox';

const urlConstants = {
  forgotCredentials: `${EnvironmentUrls.websiteUrl}/login/forgot-password-or-username`
};

export default urlConstants;
